import { render } from "./DocsLayout.vue?vue&type=template&id=2ce69b7a&scoped=true"
import script from "./DocsLayout.vue?vue&type=script&lang=js"
export * from "./DocsLayout.vue?vue&type=script&lang=js"

import "./DocsLayout.vue?vue&type=style&index=0&id=2ce69b7a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ce69b7a"]])

export default __exports__